<template>
<!-- 店铺红包 -->
<div class="viewContainer">
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="活动时间：" style="display:flex;width:23%">
            <el-date-picker type="daterange" v-model="value1" value-format="yyyy-MM-dd" @change="changetime(1)"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:90%"/>
          </el-form-item>
          <el-form-item label="所属城市：" style="display:flex;width:23%" v-if="isadmin == 1 || isplatformadmin == 1">
            <el-cascader v-model="chengshi" placeholder="请选择城市" :options="csOptions"
            filterable clearable @change="handleChangesscs" style="width:90%;"/>
          </el-form-item>
          <el-form-item style="margin-right: 10px;">
            <el-button type="danger" @click="findinfo()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-collapse-transition>
  </div>
  <div class="main_container">
    <div class="model_section">
      <p class="model_top_title">店铺红包</p>
      <el-button type="danger" @click="showadd()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
    </div>
    <div class="table_container">
      <el-table :data="envelopeList" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="活动时间" align="center">
          <template scope="scope">{{scope.row.begindate}} - {{scope.row.enddate}}</template>
        </el-table-column>
        <el-table-column label="所属城市" align="center">
          <template scope="scope">{{scope.row.area}}</template>
        </el-table-column>
        <el-table-column label="红包总金额（元）" align="center">
          <template scope="scope">{{scope.row.totalprice}}</template>
        </el-table-column>
        <el-table-column label="红包数量（个）" align="center">
          <template scope="scope">{{scope.row.totalcount}}</template>
        </el-table-column>
        <el-table-column label="已发放数量(个)" align="center">
          <template scope="scope"><b style="color:#409EFF;" @click="handleSeeLlmx(scope.row)">{{scope.row.usedcount}}</b></template>
        </el-table-column>
        <el-table-column label="已发放金额(元)" align="center">
          <template scope="scope">{{scope.row.usedprice}}</template>
        </el-table-column>
        <el-table-column label="退款金额(元)" align="center">
          <template scope="scope">{{scope.row.refundprice}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100">
          <!-- 红包状态 1=草稿 5=待开始 10=进行中 20=已结束 30=已关闭 -->
          <template scope="scope">
            {{scope.row.status==1?'草稿':scope.row.status==5?'待开始':scope.row.status==10?'进行中':scope.row.status==20?'已结束':'已关闭'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template scope="scope">
            <span class="handle" @click="handleUpper(scope.row, 1)" v-show="scope.row.status==1"> <i class="el-icon-circle-check"/> 开启 </span>
            <span class="handle" @click="handleUpper(scope.row, 2)" v-show="scope.row.status==5"> <i class="el-icon-circle-close"></i> 关闭 </span>
            <span class="handle" @click="handleUpper(scope.row, 4)" v-show="scope.row.status==10"> <i class="el-icon-remove-outline"/> 结束 </span>
            <span class="handle" @click="showadd(scope.row,1)" v-show="scope.row.status==1"><i class="el-icon-edit-outline"></i> 编辑</span>
            <span class="handle" @click="showadd(scope.row,2)" v-show="scope.row.status!=1"> <i class="el-icon-view"/> 查看 </span>
            <span class="handle" @click="handleUpper(scope.row, 3)" v-show="scope.row.status==1"> <i class="el-icon-delete"/> 删除 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 领取明细 右侧抽屉组件 -->
  <el-drawer title="红包领取明细" custom-class="registrationRecord" :visible.sync="visibleLqmx" size="30%">
    <el-table :data="lqmxList" border>
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="phone" label="用户" align="center"/>
      <el-table-column property="price" label="金额（元）" align="center"/>
      <el-table-column property="receivetime" label="领取时间" align="center"/>
    </el-table>
    <!-- 领取明细-分页 -->
    <el-pagination layout="prev, pager, next" @current-change="handleLqmx"
    :current-page="pageIndexLqmx" :page-size="10" :total="totalLqmx" style="float: right; margin-top: 10px"/>
  </el-drawer>
  
  <!-- 红包配置 -->
  <el-dialog title="红包配置" :visible.sync="dialogVisibleshenhe" :before-close="handleClose" center width="45%">
    <el-form>
      <el-form-item label="活动时间：" style="display:flex;width:50%">
        <el-date-picker type="daterange" v-model="value2" value-format="yyyy-MM-dd" @change="changetime(2)" :picker-options="pickerOptionsStart"
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%" :disabled="disabledHB"/>
      </el-form-item>
      <el-form-item label="红包配置：" style="display:flex;width:100%">
        <el-form-item v-for="(item, index) in formItems" :key="index">
          <el-row :gutter="16" style="margin-bottom: 10px;">
            <el-col :span="5">
              <el-form-item prop="price">
                <el-input type="number" v-model="item.price" placeholder="单个金额" maxlength="6" clearable :disabled="disabledHB"
                onkeyup="value=value.replace(/[^\d]/g,'');">
                  <i slot="suffix" style="margin-right: 10px;">元</i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">✖</el-col>
            <el-col :span="5">
              <el-form-item prop="count">
                <el-input v-model="item.count" placeholder="红包数量" maxlength="6" clearable :disabled="disabledHB"
                onkeyup="value=value.replace(/[^\d]/g,'');">
                  <i slot="suffix" style="margin-right: 10px;">个</i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="greeting">
                <el-input v-model="item.greeting" placeholder="红包贺词最多10个字" maxlength="10" clearable :disabled="disabledHB"/>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-button v-show="!disabledHB && index > 0" type="danger" size="small" @click="removeItem(index)">删除</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-button type="danger" size="small" @click="addItem" v-show="!disabledHB">添加配置</el-button>
      </el-form-item>
      <p>红包总额：<b>{{ RIntention }} 元</b></p>
    </el-form>
    <ul style="line-height: 26px;color: #F56C6C;">
      <li>重要提示：</li>
      <li>1.单个红包金额不低于6.66元;</li>
      <li>2.可配置多组红包，进行随机配置;</li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibleshenhe = false">{{disabledHB?"关闭":"取消"}}</el-button>
      <el-button type="danger" @click="adopt()" v-show="!disabledHB">确定</el-button>
    </span>
  </el-dialog>
  
  <!-- 确认提示 -->
  <el-dialog title='确认提示' :visible.sync="fufeidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 20px 0; font-size: 16px;">确定要支付红包费用后开启新人红包活动吗？</p>
      <b style="font-size: 18px;">-{{zysj}} 元</b>
    </div>
    <div style="text-align:center;margin-top: 20px;">
      <el-button @click="fufeidialog = false">取消</el-button>
      <el-button type="danger" @click="qdfufeu()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 微信扫码支付 -->
  <el-dialog title="请使用微信扫码支付" :visible.sync="wxsmzfVisible" width="20%" center @close="closeWxsmzf()">
    <div class="wxsmzfClass">
      <P>{{wxsmzfJine}} 元</P>
      <img :src="wxSmzfImg"/>
    </div>
  </el-dialog>
  
  <!-- 请选择活动城区弹框 -->
  <el-dialog :center="true" title="请选择活动城区" :visible.sync="visibleSynchdcq" width="25%">
    <el-form class="findform">
      <el-form-item label="活动城区：" style="display:flex;">
        <el-cascader v-model="chengshi" placeholder="请选择城市" :options="csOptions"
        filterable clearable @change="handleChangesscs" style="width:90%;"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { provincegetcountys, postPlaceOrderNative } from '../../api/newOss.js';
import { activityGetlist, activityAdd, activityGetinfo, activityEdit, receiveGetlist, activityDel, activityFinish, activityClose, activityGetpaystatus } from "../../api/attractInvestment.js";
export default {
  name: "areaRedpacketActivity",
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      value1: "", // 活动时间
      date1: "",
      date2: "",
      
      provinceId: 0,
      cityId: 0,
      zoneId: 0,
      chengshi: [],
      csOptions: [],
      visibleSynchdcq: false, // 请选择活动城区 弹框
      
      envelopeList: [],
      RIntention: 0,
      pageIndex: 1,
      total: 0,
      comId: "", // 选中行id
      dialogVisibleshenhe: false, // 红包配置
      disabledHB: false, // 红包配置-禁用
      value2: "", // 活动时间
      date3: "",
      date4: "",
      formItems: [
        {
          rpid: 0,
          price: '',
          count: '',
          greeting: ''
        }
      ],
      // 控制活动时间不能小于当前时间
      pickerOptionsStart: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
          );
        },
      },
      visibleLqmx: false, // 领取明细-抽屉
      lqmxList: [], // 领取明细-列表
      pageIndexLqmx: 1,
      totalLqmx: 0,
      
      fufeidialog: false, // 确认提示
      zysj: 0, // 金额

      wxsmzfVisible: false, // 微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码
      timer: null, // 轮询
      startTime: 0, // 初始开始请求时间
      
      isadmin: localStorage.isadmin, // 是否是超级管理员 0=否 1=是
      isplatformadmin: localStorage.isplatformadmin, // 是否是平台(全国)管理员 0=否 1=是
      
    };
  },
  methods: {
    // 活动时间
    changetime(type) {
      if(type==1){ // 检索区域
        if(this.value1+""=="null"){
          this.value1 = ["",""]
        }
        this.date1 = this.value1[0];
        this.date2 = this.value1[1];
      }else{ // 弹框
        if(this.value2+""=="null"){
          this.value2 = ["",""]
        }
        this.date3 = this.value2[0];
        this.date4 = this.value2[1];
      }
    },
    init() {
      var obj = {
        // userId: localStorage.Id, // 当前登陆人id
        businessType: 2, // 业务类型 1=店铺 2=合伙人
        beginDate: this.date1, // 红包活动起始日期
        endDate: this.date2, // 红包活动截止日期
        pid: this.provinceId, // 省份ID
        cid: this.cityId, // 城市ID
        scid: this.zoneId, // 区县ID
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      activityGetlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.envelopeList = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        } else {
          this.envelopeList = [];
          this.total = 0;
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 查询
    findinfo() {
      this.pageIndex = 1;
      this.init();
    },
    // 重置
    fnReset() {
      this.value1 = '';
      this.date1 = '';
      this.date2 = '';
      this.chengshi=[];
    },
    // 新增/编辑
    showadd(row,type) {
      if(row){
        this.dialogVisibleshenhe=true; // 红包配置
        this.comId = row.rpaid; // 红包活动ID
        // 回显接口
        let obj = {rpaId: this.comId,};
        activityGetinfo(obj).then(data => {
          let dataInfo = data.resultObj.info; // 红包活动信息
          this.comId=dataInfo.rpaid;
          this.date3=dataInfo.begindate;
          this.date4=dataInfo.enddate;
          this.value2 = [this.date3,this.date4];
          this.RIntention=dataInfo.totalprice; // 红包总金额 单位：元
          // totalcount=dataInfo.totalcount; // 红包总数量 单位：个
          this.formItems = data.resultObj.redpackets; // 红包信息集合
        })
        if(type==1){ // 编辑回显
          this.disabledHB=false;

        }else{ // 查看回显
          this.disabledHB=true;
        }
      }else{ // 新增
        if(this.isadmin == 1 || this.isplatformadmin == 1){ // admin/全国管理员
          this.chengshi=[];
          this.visibleSynchdcq = true; // 请选择活动城区
        }else{
          this.dialogVisibleshenhe=true; // 红包配置
          this.disabledHB=false;
          this.comId = "";
          this.value2 = ""; // 活动时间
          this.date3 = "";
          this.date4 = "";
          this.formItems = [
            {
              price: '',
              count: '',
              greeting: ''
            }
          ];
        }
        
      }
    },
    // 添加配置
    addItem() {
      // 验证所有输入框是否为空
      if (this.validateInputs()) {
        // 添加新的配置项
        this.formItems.push({
          price: '',
          count: '',
          greeting: ''
        });
      }
    },
    // 删除配置
    removeItem(index) {
      // 删除指定索引的配置项
      this.formItems.splice(index, 1);
    },
    // 校验
    validateInputs() {
      for (const item of this.formItems) {
        if (!item.price || !item.count || !item.greeting) {
          this.showAlert('请确保所有输入框都不为空！');
          return false;
        }
        if (item.price<6.66) {
          this.showAlert('单个金额不能低于6.66元');
          return false;
        }
      }
      return true;
    },
    // 确定
    adopt() {
      if (this.value2 == "") {
        this.showAlert('请选择活动时间');
        return false;
      }
      if(this.validateInputs()){
        if(this.comId){ var hbid = this.comId; }
        var obj = {
          rpaid: hbid, // 红包活动ID
          rpatype: 2, // 红包活动类型1=店铺红包 2=合伙人红包
          pid: this.provinceId, // 省份ID(rpatype=2时 admin/全国管理员 必传)
          cid: this.cityId, // 城市ID(rpatype=2时 admin/全国管理员 必传)
          scid: this.zoneId, // 区县ID(rpatype=2时 admin/全国管理员 必传)
          begindate: this.date3, // 开始日期
          enddate: this.date4, // 截止日期
          redpackets: this.formItems, // 红包信息集合
          // RIntention: this.RIntention,
        };
        let thisApi = this.comId==''?activityAdd:activityEdit;
        thisApi(obj).then(data => {
          if (data.resultCode == 1) {
            this.showAlert('操作成功', 'success');
            this.init();
            this.RIntention = "";
            this.handleClose(); // 关闭 红包配置 弹框
          }
        });
        // this.$swal({
        //   type: "warning",
        //   text: "是否确定配置红包",
        //   showCancelButton: true,
        //   cancelButtonText: "取消",
        //   confirmButtonText: "确定"
        // }).then(res => {
        //   if (res.value) {
            
        //   }
        // });
      }
    },
    handleClose() {
      this.dialogVisibleshenhe = false;
      this.chengshi=[];
    },
    // 红包领取明细
    handleSeeLlmx(row) {
      this.comId = row.rpaid // 红包活动ID
      this.getLlmx();
      this.visibleLqmx = true;
    },
    // 领取明细-列表
    getLlmx(){
      let addParams = {
        rpaId: this.comId, // 红包活动ID
        pageIndex: this.pageIndexLqmx, // 页码
        pageSize: 10, // 条数
      };
      receiveGetlist(addParams).then(data => {
        if (data.resultCode == 1) {
          this.lqmxList = data.resultObj.list;
          this.totalLqmx = data.resultObj.totalcount;
        } else {
          this.lqmxList = [];
          this.totalLqmx = 0;
        }
      })
    },
    // 领取明细-分页
    handleLqmx(val) {
      this.pageIndexLqmx = val;
      this.getLlmx();
    },
    // 确定
    qdfufeu(){
      this.fufeidialog=false;
      // 合伙人开启红包活动
      // attach="redpacketactivity,{rpaid},{operatorId}"
      let obj = {
        attach: 'redpacketactivity,' + this.comId +','+ localStorage.Id
      };
      postPlaceOrderNative(obj).then(data => {
        if (data.resultCode == 1) {
          this.wxsmzfVisible = true;
          this.wxsmzfJine = data.resultObj.price; // 金额（单位0）
          this.wxSmzfImg = data.resultObj.qrCode; // resultCode=1时返回base64格式二维码图片
          this.startTime = new Date().getTime() // 获取触发轮询时的时间
          this.inquireData() // 调用轮询接口,开始进行轮询
        }else{
          this.showAlert('开启成功', 'success');
          this.init();
        }
      });
    },
    // 二维码弹框-关闭
    closeWxsmzf() {
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.timer)
    },
    // 轮询请求
    inquireData () {
      const reload = () => {
        clearTimeout(this.timer) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.startTime > 5 * 60 * 1000) {
          clearTimeout(this.timer)
          return
        }
        // 3s一次, 轮询中
        this.timer = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      activityGetpaystatus('', this.comId).then(res => {
        if (res && res.resultCode === 1) {
          // 支付状态 0=未支付 5=已支付 10=已退款
          if(res.resultObj==5) {
            this.wxsmzfVisible = false; // 二维码弹窗消失
            this.showAlert('开启成功', 'success');
            this.init();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 删除3 & 结束4 & 开启/关闭
    handleUpper(row, type) {
      this.comId = row.rpaid; // 红包活动ID
      if(type==1){ // 开启
        this.zysj = row.totalprice; // 红包总金额
        this.fufeidialog=true;
        // this.$swal({
        //   type: "warning",
        //   text: "重要信息，您确定开启吗？",
        //   showCancelButton: true,
        //   reverseButtons: true, // 添加这一行来反转按钮顺序
        //   cancelButtonText: "取消",
        //   confirmButtonText: "确定"
        // }).then(res => {
        //   if (res.value) {
            
        //   }
        // });
      }else{ // 删除3 & 结束4 & 关闭2
        this.$swal({
          type: "warning",
          text: type==3?'重要信息，你确定要删除吗？':type==4?'你确定要结束吗？':'您确定关闭吗？',
          showCancelButton: true,
          reverseButtons: true, // 添加这一行来反转按钮顺序
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }).then(res => {
          if (res.value) {
            let thisApi = type==3?activityDel:type==4?activityFinish:activityClose;
            thisApi('', row.rpaid).then(data => {
              if (data.resultCode == 1) {
                this.showAlert('操作成功', 'success');
                this.init();
              }
            });
          }
        });
      }
    },
    // 计算单个金额乘以红包数量，并累加结果
    calculateTotal() {
      let total = 0;
      this.formItems.forEach(item => {
        if (item.price && item.count) {
          const price = parseFloat(item.price);
          const count = parseFloat(item.count);
          if (!isNaN(price) && !isNaN(count)) {
            total += price * count;
          }
        }
      });

      this.RIntention = total.toFixed(2); // 更新累加结果
    },
    // 请选择省市
    handleChangesscs(val) {
      this.provinceId = val[0]; // 省
      this.cityId = val[1]; // 市
      this.zoneId = val[2]; // 区
    },
    // 查找省市区
    getprovince() {
      var loginParams = {
        isopen: 1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        // 需要给区县加全市 用这段
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          item.citys.forEach(city => {
            // 添加表示“全市”的选项
            const allCityOption = {
              value: 0, label: "全市"
            };
            const cityObj = {
              value: city.cid, label: city.cname,
              children: [allCityOption].concat(city.countys.map(zone => ({
                value: zone.scid, label: zone.scname
              })))
            };
            province.children.push(cityObj);
          });
          provinceOptions.push(province);
        });
        this.csOptions = provinceOptions;
        this.csOptions.unshift({
          value: 0, label: "全国"
        });
      }).catch(error => {
        console.error('获取省市区数据失败:', error);
      });
    },
    gonext(){
      if(this.chengshi == ""){
        this.showAlert('请选择活动城区');
        return false
      }
      this.visibleSynchdcq = false;
      this.dialogVisibleshenhe=true; // 红包配置
      this.disabledHB=false;
      this.comId = "";
      this.value2 = ""; // 活动时间
      this.date3 = "";
      this.date4 = "";
      this.formItems = [
        {
          price: '',
          count: '',
          greeting: ''
        }
      ];
    },

  },
  watch: {
    'formItems': {
      handler(newVal, oldVal) {
        this.calculateTotal(); // 每当formItems变化时重新计算总和
      },
      deep: true // 监听数组内部的变化
    }
  },
  mounted() {
    this.getprovince(); // 获取省市区
    this.init();
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// areaRedpacketActivity.vue?33ccbcbc